export const SET_INITIAL_DATA = 'SET_INITIAL_DATA';
export const SET_IS_LOADING = 'SET_IS_LOADING';
export const SET_DONE_LOADING = 'SET_DONE_LOADING';
export const AUTH_ERROR_SET = 'AUTH_ERROR_SET';
export const REQUEST_IN_PROGRESS = 'REQUEST_IN_PROGRESS';
export const REQUEST_COMPLETE = 'REQUEST_COMPLETE';
export const GET_SNAPSHOT_KEY = 'GET_SNAPSHOT_KEY';